import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgGraduationCap = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="currentColor"><path d="M32 12.607v-.695L15.993 4.325 0 11.907v.705l15.993 7.582z" /><path d="M5.542 16.622v4.536l9.64 4.568h1.622l9.614-4.557c.01-.02.02-.04.026-.06v-4.487l-10.451 4.954zm24.773 6.938v-8.823l-1.267.63v8.192l-.825 2.473 1.248 1.643h.42l1.249-1.643z" /></g></svg>;
export default SvgGraduationCap;